<template>
  <PageAboutPurchase/>
</template>

<script>
import AppRouteMixin from '~/mixins/AppRouteMixin'
import PageAboutPurchase from '@theme/components/content/PageAboutPurchase'

const PAGE = {
  name: 'RouteAboutPurchase',
  nuxtI18n: {
    paths: {
      cs: '/vse-o-nakupu',
      de: '/alle-hilfethemen',
      en: '/about-purchase',
      sk: '/vsetko-o-nakupe',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageAboutPurchase,
  },
  mixins: [AppRouteMixin],
  async asyncData({ app, store, res }) {
    if (process.server) {
      res.set('X-Inspishop-Cache-Control', `public, max-age=${app.$env.STATELESS_TTL}`)
    }
    store.commit('locale/SET_CANONICALS')
  },
}
export default PAGE
</script>
